function normalizeEpoch(epoch) {

  if (epoch == null) {
    console.log("epoch is null");
    return '';
  }
  
  const epochStr = epoch.toString();

  console.log('epochStr', epochStr)

  if (epochStr.length === 10) {
      // Epoch is in seconds → convert to milliseconds
      return parseInt(epochStr, 10) * 1000;
  } else if (epochStr.length === 13) {
      // Epoch is in milliseconds → use as-is
      return parseInt(epochStr, 10);
  } else if(epochStr.length > 13) {
    const first13 = epochStr.slice(0, 13);
    return parseInt(first13, 10);
  }else 
   {
      throw new Error(`Unsupported epoch format: ${epochStr}`);
  }
}

export function formatDate(newDate, type) {
    if (newDate === '' || newDate === 0) {
        return ''
    }
    const exacttime = normalizeEpoch(newDate);
  const time = new Date(exacttime).toLocaleTimeString();
    const months = {
      0: "January",
      1: "February",
      2: "March",
      3: "April",
      4: "May",
      5: "June",
      6: "July",
      7: "August",
      8: "September",
      9: "October",
      10: "November",
      11: "December"
    };
    // const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    
    const d =  new Date(exacttime);
    const year = d.getFullYear();
    const date = d.getDate();
    // const monthIndex = d.getMonth();
    const monthName = months[d.getMonth()];
    // const dayName = days[d.getDay()]; // Thu

    const formatted = ` ${monthName} ${date}, ${year}`;
    if(type === 'invoice'){
      return formatted.toString() + " " + time;
    }else {
      return formatted.toString();
    }
  }